import {RecordReadingStateMap, IReviewWord, ReviewWordColor} from "../services/usermodel/usermodel.objects";
import {ContentCssClass, CssSentence, CssText, CssSelection} from "./content-view.objects";

export class ContentFormatter {

    public static wordColorToCssClass(wordColor: ReviewWordColor): ContentCssClass {
        switch (wordColor) {
            case ReviewWordColor.GREAT_JOB:
                return ContentCssClass.WORD_GREAT_JOB;
            case ReviewWordColor.NEEDS_WORK:
                return ContentCssClass.WORD_NEEDS_WORK;
            case ReviewWordColor.TRY_AGAIN:
                return ContentCssClass.WORD_TRY_AGAIN;
            default:
                return <any>"";
        }
    }

    public static formatSelectionFromCurrentRecordingSentence(selection: CssSelection,
                                                         currentSentence: number): void {
        selection.text.forEach(text => {
            ContentFormatter.formatTextFromCurrentRecordingSentence(text, currentSentence);
        });
    }

    public static formatTextFromCurrentRecordingSentence(text: CssText, currentSentence: number): void {
        text.sentences
            .forEach(s => {
                ContentFormatter.setSentenceRecorded(s, parseInt(s.id, 10) <= currentSentence);
            });
    }
    public static setSentenceRecorded(sentence: CssSentence, sentenceIsRecorded: boolean,
                                      viewMode?: ContentCssClass): void {
        // TODO: better way to structure this in CSS?  really sentence can only be recorded OR unrecorded,
        // but in current structure both classes can be added/set which is nonsensical
        if (viewMode && (viewMode === ContentCssClass.MODE_RECORDING)) {
            if (sentenceIsRecorded) {
                sentence.removeCssClass(ContentCssClass.SENTENCE_CURRENT);
            } else {
                sentence.addCssClass(ContentCssClass.SENTENCE_CURRENT);
            }
        } else {
            if (sentenceIsRecorded) {
                sentence.removeCssClass(ContentCssClass.SENTENCE_UNRECORDED);
                sentence.addCssClass(ContentCssClass.SENTENCE_RECORDED);
            } else {
                sentence.removeCssClass(ContentCssClass.SENTENCE_RECORDED);
                sentence.addCssClass(ContentCssClass.SENTENCE_UNRECORDED);
            }
        }
    }

    public static formatSelectionFromRecordReadingStates(selection: CssSelection,
                                                         statesMap: RecordReadingStateMap): void {
        selection.text.forEach(text => {
            ContentFormatter.formatTextFromRecordReadingStates(text, statesMap);
        });
    }

    public static formatTextFromRecordReadingStates(text: CssText, statesMap: RecordReadingStateMap): void {
        text.sentences
            .forEach(sentence => {
                const reviewWords: IReviewWord[] = statesMap[sentence.id];
                ContentFormatter.formatSentenceFromRecordReadingStates(sentence, reviewWords);
            });
    }

    public static formatSentenceFromRecordReadingStates(sentence: CssSentence, reviewWords: IReviewWord[]): void {
        if (reviewWords) {
            sentence.addCssClass(ContentCssClass.SENTENCE_RECORDED);

            sentence.words.forEach(word => {
                const id = Number(word.id);
                // Note: Possible performance issue here, but it ensures finding all matches regardless of order
                const reviewWord = reviewWords.find(word => word.wordId === id);
                if (reviewWord) {
                    word.removeCssClass(ContentCssClass.WORD_TRY_AGAIN);
                    word.removeCssClass(ContentCssClass.WORD_GREAT_JOB);
                    word.removeCssClass(ContentCssClass.WORD_NEEDS_WORK);
                    word.addCssClass(ContentFormatter.wordColorToCssClass(reviewWord.wordColor));
                } else {
                    console.error(`CssWord id ${word.id} doesn't match any ReviewWord id`);
                }
            });

        } else {
            sentence.addCssClass(ContentCssClass.SENTENCE_UNRECORDED);
        }
    }
}
